export default __webpack_public_path__ + "static/industryAdaptbg-5be9a1042671810ca312d38121815e85.png";